export default {
  common: {
    chiller: "冷机",
    chilledWaterPump: "冷冻水泵",
    coolingTower: "冷却塔",
    nextStep: "下一步",
    previousStep: "上一步",
    objective: "项目目标",
    preRetrofit: "改造前",
    postRetrofit: "改造后",
    retrofitSetup: "改造设置",
    equipmentRated: "设备铭牌",
    equipmentConfig: "设备与配置",
    retrofitSummary: "改造信息汇总",
    cwp: "冷却水泵",
    condenderWaterPump: "冷却水泵",
    chwp: "冷冻水泵",
    ct: "冷却塔",
    other: "其他",
    otherEquipment: "其他设备",
    chillerOneNos: "冷机 (1 台)",
    condenderWaterPumpOneNos: "冷却水泵 (1 台)",
    chilledWaterPumpOneNos: "冷冻水泵 (1 台)",
    coolingTowerFanOneNos: "冷却塔风扇 (1 台)",
    controlOptimization: "控制优化",
    commonHeader: "共用总管",
    dedicatedOneOnOne: "专用的 (1-1)",
    pleaseInput: "请输入",
    pleaseEnterHere: "请在此处输入",
    cancel: "取消",
    confirm: "确认",
    years: "年",
    noProjectInfo: "未找到项目信息",

    pleaseInputData: "请输入数据",
    systemOptionRequired: "请输入系统选项",
    proposedEquipmentRequired: "请输入建议设备",

    profileEquipmentSetting: "配置文件设备设置",
    Total: "总计"
  },
  objective: {
    projectObjective: "项目目标",
    chillerEfficiency: "冷机效率",
    chillerPlantEfficiency: "冷站效率",
    heatingEfficiency: "热泵效率",
    heatingPlantEfficiency: "热泵机组效率",
    chillerHeatingEfficiency: "冷机/供热效率",
    pleaseSelectAProjectObjective: "请选择一项项目目标",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: " ( 1 - 1 ) 或 机组",
    projectName: "当前项目名称",
    doYouWantSave: "关闭本页前，你想将数据保存到云端吗 ?",
    start: "开始",
    quickNavigation: "快捷导航",
    mainMenu: "项目主菜单",

    establishBaseline: "建立基线 (改造前)",
    profile: "简介资料",
    siteObservation: "现场观察",
    equipmentSpecification: "设备规范",
    baselineInput: "基线输入",
    summary: "汇总",
    generateReport: "生成报告",

    finalizeYourProposal: "解决方案选项（改造后）",
    finalizeAnalysis: "最终分析",
    retrofitSetup: "改造设置",
    equipmentConfig: "设备与配置",
    financialAnalysis: "财务分析",
    proposedConfig: "建议配置",
    systemOption: "系统选项",
    ProfileEquipment: "配置文件与设备",
    baselinePreview: "基线预览",
    profileEquipment: "配置文件和设备",
    selectProposedEquipments: "选择拟用设备",
    pleaseSelectEquipments: "请选择设备",

    clusterSetting: "集群设置",
    generateOption: "生成选项",

    baselineConfig: "基线配置",
    monthlyBaseline: "月度基线"
  },
  setup: {
    systemOption: "系统选项",
    chillerOnly: "冷机",
    chillerWithAssociatedEquipment: "冷机及相关设备",
    controlOnly: "控制",
    proposedLayout: "建议布局",
    series: "串联",
    parallel: "并联",
    proposedEquipment: "建议设备"
  },
  rated: {
    newEquipment: "添加设备",
    ratedInputPower: "额定输入功率",
    ratedCoolingCapacity: "额定制冷量",
    chillerLabel: "冷机名",
    type: "类型",
    chillerBrandModel: "冷水机品牌和型号",
    yearInstalled: "安装年份",
    ratedDesignFlowRate: "额定设计流量",
    pressureHead: "扬程",
    vfd: "是否安装了变频器",
    yes: "有",
    no: "无",
    noofFansCT: "风扇数量/CT",
    equipmentLabel: "设备名称",
    category: "类别",
    brand: "品牌",
    otherEquipment: "其他设备",
    inputEcatPerformanceData: "输入Ecat性能数据",
    load: "负荷",
    coolingLoad: "冷负荷",
    inputPower: "输入功率",
    chillerWaterPumpLabel: "冷水泵名称",
    ratedMotorFrequency: "额定电机频率",
    minimumMotorFrequency: "最小电机频率",
    motor: "电机 (kW)",
    applicableChiller: "适用冷机",
    condenserWaterPumpLabel: "冷却水泵名称",
    coolingTowerLabel: "冷却塔名称",
    ratedFanFrequency: "额定风扇频率",
    minimumFanFrequency: "最小风扇频率",
    totalRatedFanPowerPerCT: "每个CT的总额定风扇功率",
    heatRejectionCapacityPerCT: "每个CT的散热能力",
    chillerLabelRequired: "填写冷机名",
    yellowBlockRequired: "黄色输入框必singlePrice填",
    labelRequired: "设备名称必填",
    maximumQuantity: "已到数量上限",

    chilledWaterSupplyTemp: "冷冻水供应温度",
    outdoorAirTemp: "室外空气温度",

    condenserWaterSupplyTemp: "冷却水供水温度",
    singleChillerSellingPrice: "单台冷机售价",
    singleCHWPSellingPrice: "单台CHWP售价",
    singleCWPSellingPrice: "单台CWP售价",
    singleCTSellingPrice: "单台CT售价",

    singlePrice: "单台售价"
  },
  summary: {
    chooleYourPreference: "选择方案偏好",
    higherEfficiencyImprovement: "更高的能效提升",
    lowerInvestment: "更低的投资",
    higherCostSaving: "更低的成本",
    shorterPaybackPeriod: "更短投资回收期",
    option: "方案选项",
    efficiencyImprovement: "提高能效",
    returnOnInvestment: "投资回报",
    costSavingsPerYear: "每年节省成本",
    paybackPeriod: "投资回收期",
    optionDetails: "方案选项详情",
    postRetrofitEfficiency: "改造后能效",
    totalEnergySavingsPerYear: "每年总节能量",
    investmentAnalysis: "投资分析 (实际的)",
    capex: "资本支出",
    sellingPrice: "售价",
    OverallProjectPrice: "项目总价",
    chillerCooling: "冷机制冷",
    chillerHeatPump: "冷机热泵",
    calculate: "计算",
    proposedConfig: "建议配置",
    projectIntroduction: "项目简介",
    assumptions: "前提",
    chillerPlant: "冷站",
    chillerPlantConfig: "冷站配置",
    peakBuildingCoolingLoad: "建筑冷负荷峰值",
    designChilledWaterSupplyTemp: "设计冷冻水供水温度",
    designCondenserWaterSupplyTemp: "设计冷却水供水温度",
    energyConservationMeasures: "节能措施",
    pumpingConfig: "泵机配置",
    designFlowRate: "设计流量",
    designPressureHead: "设计扬程",
    vfdFitted: "已装 VFD",
    chillerConfig: "冷机配置",
    condenserWaterPump: "冷却水泵",
    coolingTowerConfig: "冷却塔配置",
    heatRejectionCapacity: "排热能力",
    designCoolingTowerApproach: "冷却塔设计方法",
    generateReport: "生成报告",
    confirmCalculation: "确认计算",
    doYouNeedCalculationAgain: "系统发现已经存在计算结果，你是否需要重新进行计算",
    recalculate: "重新计算",
    coolingTower: "冷却塔",
    chiller: "冷机",
    chilledWaterPump: "冷冻水泵",

    fillValidNumericalValue: "请输入一个有效数值",

    runningNumber: "运行台数"
  },
  profileMap: {
    associatedCWP: "关联 CWP",
    associatedCHWP: "关联 CHWP",
    associatedCT: "关联冷却塔",
    profileId: "配置文件ID",
    donotNeedmanipulate: "自动模式下，您无需对配置文件进行操作5.",

    automatic: "自动关联",
    manual: "手动关联",
    pathAndMethod: "生成方法",
    months: "包含月",
    running: "运行",
    daysPerMonth: "天 / 月",
    chiller: "冷机"
  }
  // reportFocusDlg: {
  //   selectCustomerReportingFocus: "选择客户报告重点",
  //   roiLedSummary: "ROI导向总结",
  //   roiLedSummaryDetails: "当项目已具备投资成本、节能收益及投资回收期等财务数据时使用。",
  //   efficiencyImprovementLedSummary: "效率提升导向总结",
  //   efficiencyImprovementLedSummaryDetails: "当决策主要基于能效提升，且ROI数据无法获取或参考意义有限时使用。"
  // }
}



// WEBPACK FOOTER //
// ./src/locale/post/zh.js